module.exports = __webpack_public_path__ + "static/media/furia-wireframing.a7afe4ed.svg";